import { api } from '@/api';
import type { SheetAnnotations, SheetRead } from './types';

const BASE = 'v1/artifacts';

export const getSheet = (artifactId: string, revision?: number) =>
  api.get<SheetRead>(`${BASE}/${artifactId}/sheet`, { params: { revision } });

export const getSheetAnnotations = (artifactId: string) =>
  api.get<SheetAnnotations>(`${BASE}/${artifactId}/sheet/annotations`);

export const saveSheet = (artifactId: string, body: { expectedState: string }) =>
  api.post<{ revision: number }>(`${BASE}/${artifactId}/sheet/snapshot`, body);
